import { FC, useMemo } from "react"
import AlertSoundSettings from "@/components/AlertSoundSettings"
import {
   alertFrequencyOptions,
   noSoundFile,
   soundFiles,
} from "@/components/AlertSoundSettings/files"
import Loader from "@/components/Loader"
import GridItem from "@/components/shared/Grid/GridItem"
import { SpinnerSize } from "@/components/shared/Spinner"
import { AlertSound } from "@/types/alert"
import { AlertConfigurationForm } from "@/types/alertConfigurations"
interface SoundProps {
   loading: boolean
   alarmName?: string
   soundFileId: number | string
   soundFrequency: string
   onSave: (args: AlertConfigurationForm["sound"]) => void
}

const Sound: FC<SoundProps> = ({
   loading,
   alarmName = "",
   soundFileId,
   soundFrequency,
   onSave,
}) => {
   const soundFile = useMemo(() => {
      return soundFiles.find((file) => file.id === soundFileId) || noSoundFile
   }, [soundFileId])
   const alertSoundFrequency = useMemo(() => {
      return (
         alertFrequencyOptions.find((freq) => freq.value === soundFrequency) ||
         alertFrequencyOptions[0]
      )
   }, [soundFrequency])

   const handleSave = (state: AlertSound) => {
      onSave({
         clip: state.clip,
         frequency: state.frequency,
      })
   }

   return (
      <GridItem size={2}>
         {loading ? (
            <div className="alert-setting-detail--loading">
               <Loader
                  size={SpinnerSize.SMALL}
                  fullHeight={false}
               />
            </div>
         ) : (
            <AlertSoundSettings
               alarmName={alarmName}
               soundFile={soundFile}
               soundFrequency={alertSoundFrequency}
               onSave={(soundFile, soundFrequency) => {
                  handleSave({
                     clip: soundFile.id,
                     frequency: soundFrequency.value,
                  })
               }}
            />
         )}
      </GridItem>
   )
}

export default Sound
